import React, { useState, useEffect, forwardRef, useImperativeHandle } from "react";

const MultiSelectEditor = forwardRef((props, ref) => {
    const [value, setValue] = useState(props.value || []);

    // AG Grid API contract: expose getValue so it knows what to save
    useImperativeHandle(ref, () => ({
        getValue() {
            return value;
        }
    }));

    const toggleOption = (option) => {
        if (value.includes(option)) {
            setValue(value.filter((v) => v !== option));
        } else {
            setValue([...value, option]);
        }
    };

    return (
        <div style={{ padding: "4px" }}>
            {props.values.map((option) => (
                <label key={option} style={{ display: "block" }}>
                    <input
                        type="checkbox"
                        checked={value.includes(option)}
                        onChange={() => toggleOption(option)}
                    />
                    {option}
                </label>
            ))}
        </div>
    );
});

export default MultiSelectEditor;
